import { createSlice } from "@reduxjs/toolkit";
import { fetchCurrUser } from "../thunks/users.thunks";
import {
  checkIfFavorited,
  getAllFavorites,
  getAllFavoritesData,
  removeFavorite,
} from "../thunks/favorites.thunks";

const initialState = {
  user: null,
  favorites: [],
  favorites_data: [],
  isLoading: false,
  isFavoriteLoading: false,
  isError: null,
};

const favorites = createSlice({
  name: "favorites",
  initialState,
  reducers: {
    setUser(state, action) {
      state.user = action.payload;
    },
  },
  extraReducers: (builder) => {
    // FETCH CURRENT USER
    builder.addCase(fetchCurrUser.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchCurrUser.fulfilled, (state, action) => {
      state.user = action.payload;
      state.isLoading = false;
    });
    builder.addCase(fetchCurrUser.rejected, (state, action) => {
      state.isLoading = false;
      console.log(action.error);
    });

    // CHECK IF FAVORITED
    builder.addCase(checkIfFavorited.pending, (state, action) => {
      state.isFavoriteLoading = true;
    });
    builder.addCase(checkIfFavorited.fulfilled, (state, action) => {
      state.isFavoriteLoading = false;
    });
    builder.addCase(checkIfFavorited.rejected, (state, action) => {
      state.isFavoriteLoading = false;
      console.log(action.error);
    });

    // REMOVE FAVORITES
    builder.addCase(removeFavorite.pending, (state, action) => {
      state.isFavoriteLoading = true;
    });
    builder.addCase(removeFavorite.fulfilled, (state, action) => {
      let author = action.payload.author;

      state.isFavoriteLoading = false;

      // Remove from favorites
      state.favorites = state.favorites.filter(
        (favorite) => favorite.comment_author !== String(author)
      );

      // Remove from favorites_data
      state.favorites_data = state.favorites_data.filter(
        (car) => car.id !== author
      );
    });
    builder.addCase(removeFavorite.rejected, (state, action) => {
      state.isFavoriteLoading = false;
      console.log(action.error);
    });

    // GET ALL FAVORITES
    builder.addCase(getAllFavorites.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getAllFavorites.fulfilled, (state, action) => {
      state.favorites = action.payload;
      state.isLoading = false;
    });
    builder.addCase(getAllFavorites.rejected, (state, action) => {
      state.isLoading = false;
      console.log(action.error);
    });

    // GET ALL FAVORITES WITH THEIR DATA
    builder.addCase(getAllFavoritesData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getAllFavoritesData.fulfilled, (state, action) => {
      state.favorites_data = action.payload;
      state.isLoading = false;
    });
    builder.addCase(getAllFavoritesData.rejected, (state, action) => {
      state.isLoading = false;
      console.log(action.error);
    });
  },
});

// Export the reducer to be included in the store
export const favoritesReducer = favorites.reducer;
export const { setUser } = favorites.actions;
